import { Ref, nextTick, onMounted, onUpdated, ref } from 'vue';

export default function useTextRowCount(elementRef: Ref<HTMLElement | null>): Ref<number> {
  const textRowCount = ref(0);

  const updateRowCount = async () => {
    if (elementRef.value) {
      await nextTick();
      const computedStyle = getComputedStyle(elementRef.value);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const height = elementRef.value.scrollHeight;
      textRowCount.value = Math.floor(Number(height) / lineHeight);
    }
  };

  onMounted(updateRowCount);
  onUpdated(updateRowCount);

  return textRowCount;
}
